var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString, IsEmail, IsIn, IsOptional, IsPostalCode, IsAlphanumeric } from 'class-validator';
import { IsChecked } from './validators/isChecked';
var NeighbourhoodFormDto = /** @class */ (function () {
    function NeighbourhoodFormDto(purpose) {
        if (purpose) {
            this.purpose = purpose;
        }
    }
    NeighbourhoodFormDto.prototype.toModel = function () {
        return {
            purpose: this.purpose,
            neighbourhood_name: this.neighbourhoodName,
            email_address: this.emailAddress,
            phone_number: this.phoneNumber,
            comment: this.comment,
            zip_code: this.zip,
            city: this.city,
            street_name: this.street,
            house_number: this.number
        };
    };
    __decorate([
        IsIn([1, 2]),
        __metadata("design:type", Number)
    ], NeighbourhoodFormDto.prototype, "purpose", void 0);
    __decorate([
        IsString(),
        __metadata("design:type", String)
    ], NeighbourhoodFormDto.prototype, "neighbourhoodName", void 0);
    __decorate([
        IsEmail(),
        __metadata("design:type", String)
    ], NeighbourhoodFormDto.prototype, "emailAddress", void 0);
    __decorate([
        IsString(),
        IsOptional(),
        __metadata("design:type", String)
    ], NeighbourhoodFormDto.prototype, "phoneNumber", void 0);
    __decorate([
        IsChecked(),
        __metadata("design:type", Boolean)
    ], NeighbourhoodFormDto.prototype, "terms", void 0);
    __decorate([
        IsPostalCode('AT'),
        __metadata("design:type", Number)
    ], NeighbourhoodFormDto.prototype, "zip", void 0);
    __decorate([
        IsString(),
        __metadata("design:type", String)
    ], NeighbourhoodFormDto.prototype, "city", void 0);
    __decorate([
        IsString(),
        __metadata("design:type", String)
    ], NeighbourhoodFormDto.prototype, "street", void 0);
    __decorate([
        IsAlphanumeric(),
        IsOptional(),
        __metadata("design:type", String)
    ], NeighbourhoodFormDto.prototype, "number", void 0);
    return NeighbourhoodFormDto;
}());
export { NeighbourhoodFormDto };
